<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="btn-right-side mb10">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleCreate" v-hasPermi="['aiTrain:knowledge:add']">上传素材</el-button>
      </div>
      <el-table v-loading="listLoading" :data="list" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="title" label="标题" min-width="160" show-overflow-tooltip />
        <el-table-column label="文件" width="120">
          <template slot-scope="{row}">
            <a v-if="row.fileUrl" :href="row.fileUrl" target="_blank">查看原文件</a>
          </template>
        </el-table-column>
        <el-table-column prop="charCount" label="解析字数" width="100" />
        <el-table-column label="解析状态" width="110">
          <template slot-scope="{row}">
            <el-tag size="mini" :type="parseStateType(row.parseStatus)">{{ parseStateLabel(row.parseStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="解析预览" min-width="240">
          <template slot-scope="{row}">
            <span class="preview-text">{{ (row.parsedText || '').slice(0, 60) }}{{ row.parsedText && row.parsedText.length > 60 ? '…' : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="160" />
        <el-table-column label="操作" width="180">
          <template slot-scope="{row}">
            <el-button type="text" size="mini" @click="handlePreview(row)">预览全文</el-button>
            <el-button type="text" size="mini" @click="handleReparse(row)" v-hasPermi="['aiTrain:knowledge:edit']">重新解析</el-button>
            <el-button type="text" size="mini" style="color:#f56c6c" @click="handleDelete(row)" v-hasPermi="['aiTrain:knowledge:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="onPagination" />
    </el-card>

    <el-dialog title="上传素材" :visible.sync="dialogVisible" width="520px" :close-on-click-modal="false">
      <el-form ref="dataForm" :model="form" :rules="formRules" label-width="80px" size="small">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" maxlength="60" show-word-limit />
        </el-form-item>
        <el-form-item label="文件" prop="fileUrl">
          <file-upload v-model="fileList" file-txt="选择文件" :limit="1" limit-type=".txt,.md,.doc,.docx,.pdf" hint-text="支持 TXT、MD、DOC、DOCX、PDF，最大20MB；扫描图片PDF需先转换为可选中文字的文档" @input="onFileChange" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitForm">保存并解析</el-button>
      </div>
    </el-dialog>

    <el-dialog title="解析全文预览" :visible.sync="previewVisible" width="700px">
      <div class="parsed-text">{{ previewText || '（尚未解析出内容）' }}</div>
    </el-dialog>
  </div>
</template>

<script>
import { listRows } from '@/utils/ai-train-data'
import aiTrainKnowledgeApi from '@/api/aiTrain/knowledge'
import Pagination from '@/components/Pagination'
import FileUpload from '@/components/FileUpload'

export default {
  name: 'AiTrainKnowledge',
  components: { Pagination, FileUpload },
  data() {
    return {
      query: { pageNo: 1, pageSize: 10 },
      list: [],
      total: 0,
      listLoading: false,
      dialogVisible: false,
      saving: false,
      form: { title: '', fileUrl: '' },
      fileList: [],
      formRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        fileUrl: [{ required: true, message: '请上传文件', trigger: 'change' }]
      },
      previewVisible: false,
      previewText: ''
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    onPagination({ pageNo, pageSize }) {
      this.query.pageNo = pageSize === this.query.pageSize ? pageNo : 1
      this.query.pageSize = pageSize
      this.loadList()
    },
    parseStateLabel(state) {
      const label = { 0: '待解析', 1: '已解析', 2: '解析失败' }[state]
      return label !== undefined ? label : '状态未知'
    },
    parseStateType(state) {
      return { 0: 'info', 1: 'success', 2: 'danger' }[state] || 'info'
    },
    loadList() {
      this.listLoading = true
      aiTrainKnowledgeApi.fetchList(this.query)
        .then(res => {
          const data = (res && res.data) || res || {}
          this.list = listRows(data)
          this.total = data.total || this.list.length
        })
        .catch(() => { this.list = []; this.total = 0 })
        .finally(() => { this.listLoading = false })
    },
    handleCreate() {
      this.form = { title: '', fileUrl: '' }
      this.fileList = []
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
    },
    onFileChange(val) {
      this.form.fileUrl = (val && val[0] && (val[0].url || val[0])) || ''
    },
    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.saving = true
        aiTrainKnowledgeApi.create(this.form)
          .then(() => {
            this.$message.success('素材已保存，请查看解析状态')
            this.dialogVisible = false
            this.loadList()
          })
          .catch(() => {}).finally(() => { this.saving = false })
      })
    },
    handlePreview(row) {
      this.previewText = row.parsedText || ''
      this.previewVisible = true
    },
    handleReparse(row) {
      aiTrainKnowledgeApi.reparse(row.id).then(() => {
        this.$message.success('解析处理完成，请查看解析状态')
        this.loadList()
      })
    },
    handleDelete(row) {
      this.$common.confirm('是否确认删除该素材？').then(() => aiTrainKnowledgeApi.deleteById(row.id))
        .then(() => {
          this.$message.success('删除成功')
          this.loadList()
        })
    }
  }
}
</script>

<style scoped>
.mb10 { margin-bottom: 10px; }
.preview-text { color: #909399; font-size: 12px; }
.parsed-text { max-height: 60vh; overflow-y: auto; white-space: pre-wrap; line-height: 1.6; }
</style>
